<p class="text-2xl font-medium mb-6">Часто задаваемые вопросы</p>
<div class="flex flex-col gap-4">
  @for (question of  questions; track question.question; let i =  $index){
    <app-frequent-question
      [question]="question"
      [index]="i"
      class="break-inside-avoid block"
    />
  }
</div>
